export default __webpack_public_path__ + "static/media/Pistol_3.756f140c.png";